import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "iconPicker" }
const _hoisted_2 = { class: "p-mt-2 p-field" }
const _hoisted_3 = { class: "p-inputgroup" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = { for: "searchIcon" }
const _hoisted_6 = { class: "p-mt-4" }
const _hoisted_7 = { class: "iconPicker__icons" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, "fontawesome", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KnImageToBase64IconPicker = _resolveComponent("KnImageToBase64IconPicker")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.$t('managers.menuManagement.chooseIcon'),
    visible: _ctx.modalShown,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalShown = $event)),
    style: { width: '50vw' },
    modal: true,
    closable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Cancel",
        icon: "pi pi-times",
        onClick: _ctx.closeModal,
        class: "p-button-text"
      }, null, 8, ["onClick"]),
      _createVNode(_component_Button, {
        label: "Choose",
        icon: "pi pi-check",
        disabled: _ctx.disableChoosen,
        onClick: _ctx.chooseIcon,
        autofocus: ""
      }, null, 8, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_KnImageToBase64IconPicker, {
        onSelectedImageBase64: _ctx.onBase64ImageSelection,
        onWrongInput: _ctx.toggleDisableChooseButton
      }, null, 8, ["onSelectedImageBase64", "onWrongInput"]),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, [
              _createVNode(_component_InputText, {
                id: "searchIcon",
                type: "text",
                onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterIcons($event))),
                class: "p-inputtext p-component kn-material-input"
              }),
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('common.search')), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.localIcons, (icon) => {
              return (_openBlock(), _createBlock("a", {
                key: icon.id,
                href: "#",
                class: `item ${_ctx.selected === icon.id ? 'selected' : ''}`,
                title: icon.id,
                onClick: _withModifiers(($event: any) => (_ctx.getIcon(icon)), ["stop","prevent"])
              }, [
                _createVNode("i", {
                  class: `fa-${icon.membership?.free[0] || 'solid'} fa-${icon.id}`
                }, null, 2)
              ], 10, ["title", "onClick"]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["header", "visible"]))
}